module.exports = __webpack_public_path__ + "img/drvinglicense.7c4c52d4.png";